import React from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import PropTypes from 'prop-types';
import WithLoader from '../Loader/WithLoader';
import { useDispatch, useSelector } from 'react-redux';
import { ClinicNearbyStyled } from './ClinicNearbyStyled';
import {
  getClincsItemObject,
  sendClinicClickEvent,
  viewAllLinkClick,
} from '@common/Utility/analytics-utils';
import { CLINIC_URL, TELECONSULT_ROUTE } from '@common/Utility/constants';
import { errorHandling, URL_QUERY, getImageSrc, checkIfCurrentRegionIsSaudi } from '@common/Utility/common-utils';
import Image from 'next/image';
import SectionBox from '../SectionBox/SectionBox';
import SlickSlider from '../SlickSlider/SlickSlider';
import { getClinicList } from 'aster-foundation/core/teleconsultant/clinic/redux/actions';
import { getClinicListings } from '@common/Utility/insider-object-integration';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const responsive = [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3.5,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2.5,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 2.2,
    },
  },
];

const ClinicNearby = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation();
  const clinicLoading = useSelector((state) => state?.teleconsultant?.getClinicList?.isFetching);
  const clinicNearYou = useSelector((state) => state?.teleconsultant?.clinicList?.data?.data);
  const userLocation = useSelector((state) => state?.app?.userLocationReducer?.location);
  const dispatch = useDispatch();

  const navigateToAllClinic = (name) => {
    viewAllLinkClick(props?.screen, props?.title);
    const distance = clinicNearYou?.filter((itm) => itm.sortByDistance != null && itm.sortByDistance < 5 === true);
    const facilityIds = distance?.map((i) => i.facilityId);
    const facilityNames = distance?.map((i) => i.name);
    router.push({ pathname: generateURL(`${TELECONSULT_ROUTE}/${CLINIC_URL}`) });
  };

  React.useEffect(() => {
    props.setLoading(clinicLoading);
  }, [clinicLoading]);

  React.useEffect(() => {
    if (userLocation && !checkIfCurrentRegionIsSaudi()) {
      dispatch(
        getClinicList({
          queryParam: {
            lat: userLocation.lat,
            long: userLocation.lng,
          },
          onSuccess: (response) => {
            if (response?.data && response?.data?.length > 0) {
              const items = response?.data?.map((element, index) => {
                return {
                  ...getClincsItemObject(element),
                  index: index + 1,
                  taxonomy: ['Teleconsultation', element?.facilityType],
                  unit_price: 0,
                  unit_sale_price: 0,
                  stock: 1,
                  url: `${location?.origin}${TELECONSULT_ROUTE}/f/${element?.uriPath?.replace(URL_QUERY, '')}/${
                    element?.id
                  }?type=all`,
                  product_image_url:
                    element?.facilityImageWeb?.length > 0 ? element?.facilityImageWeb[0] : element?.image,
                  ...getClinicListings(element),
                };
              });
            }
          },
          onFailure: (err) => {
            errorHandling(err);
          },
        }),
      );
    }
  }, [userLocation]);

  return (
    <ClinicNearbyStyled className={props?.outerClass}>
      {clinicNearYou !== undefined && clinicNearYou?.length !== 0 && (
        
        <SectionBox
          customClass=""
          customOuterClass="pb-4 whiteBg"
          rightTop={
            <Link href={generateURL(`${TELECONSULT_ROUTE}/${CLINIC_URL}`)} passHref={true}>
            <a className="link cursor-pointer" onClick={() => navigateToAllClinic('clinic')}>
              {t('EPharmacyHome.viewAll')}
            </a>
            </Link>
          }
          title={props.title}
        >
          <SlickSlider
            sliderSettings={{
              responsive: responsive,
              slidesToShow: 4.4,
              infinite: false,
              className: 'clinicSlider',
              dots: false,
            }}
          >
            {clinicNearYou?.map((item) => {
              return (
                <Link  href={generateURL(`${TELECONSULT_ROUTE}/f/${item?.uriPath?.replace(URL_QUERY, '')}/${item?.id}?type=home`)} passHref={true}>
                  <a>
                <div
                  className="item cursor-pointer"
                  key={item?.id}
                  onClick={() => {
                    sendClinicClickEvent(props?.screen, item);
                  }}
                >
                  <div className="itemBox">
                    <div className="image">
                      {item?.facilityThumbnailWeb?.[0] ? (
                        <Image
                          src={getImageSrc(item?.facilityThumbnailWeb?.[0])}
                          width="100%"
                          height="100%"
                          alt={item?.name}
                        />
                      ) : null}
                    </div>
                    <div className="details">
                      <div className="name line-clamp">{item?.name}</div>
                      <div className="type">{item?.clinicType}</div>
                      <div className="location">{item?.area}</div>
                      <div className="distance">{item?.distance ? item?.distance + ` ${t('DoctorDetails.away')}` : ''} </div>
                      <div className="arrow"></div>
                    </div>
                    {item.doctorCount !== 0 && (
                      <div className="doctors">{item.doctorCount === 0 ? '' : `${item.doctorCount} ${t('homeScreen.Doctors')}`}</div>
                    )}
                  </div>
                </div>
                </a>
              </Link>
              );
            })}
          </SlickSlider>
        </SectionBox>
      )}
    </ClinicNearbyStyled>
  );
};

ClinicNearby.propTypes = {
  outerClass: PropTypes.string,
  setLoading: PropTypes.any,
  screen: PropTypes.string,
  title: PropTypes.string,
};

export default WithLoader(ClinicNearby);
